import { render, staticRenderFns } from "./MyFileImport.vue?vue&type=template&id=a14ff570&scoped=true"
import script from "./MyFileImport.vue?vue&type=script&lang=js"
export * from "./MyFileImport.vue?vue&type=script&lang=js"
import style0 from "./MyFileImport.vue?vue&type=style&index=0&id=a14ff570&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a14ff570",
  null
  
)

export default component.exports